import React, { MouseEventHandler } from 'react';
import { Button } from 'react-bootstrap';

interface IEditButtonProps {
  /**
   * @default: false
   */
  isBusy?: boolean;
  /**
   * @default: false
   */
  isEditing?: boolean;

  /**
   * then label to display
   */
  label: string;

  /**
   * callback for when editing is clicked
   * will not be called for submit
   */
  onEdit?: MouseEventHandler<HTMLElement>;
}

const getDisplayLabel = (
  fallback: string,
  isBusy?: boolean,
  isEditing?: boolean
): string => {
  if (isBusy) {
    return 'Loading ...';
  }
  if (isEditing) {
    return 'Save changes';
  }
  return fallback;
};

export const EditSubmitButton = ({
  isBusy = false,
  isEditing = false,
  label,
  onEdit,
}: IEditButtonProps) => {
  const displayLabel = getDisplayLabel(label, isBusy, isEditing);

  const type = isEditing ? 'submit' : undefined;
  const variant = isEditing ? 'secondary' : undefined;
  const clickHandler: MouseEventHandler<HTMLElement> | undefined = isEditing
    ? undefined
    : (e) => {
        e.preventDefault();
        onEdit?.(e);
      };

  return (
    <Button
      type={type}
      className="px-5 mt-5"
      size="sm"
      disabled={isBusy}
      variant={variant}
      onClick={clickHandler}
    >
      {displayLabel}
    </Button>
  );
};
